<!-- Sidebar Header starts -->
<div class="sidebar-header">
  <div class="logo clearfix">
    <a [routerLink]="['/home'| localize]" title="{{'Home' | translate}}" class="logo-text float-left">
      <div class="logo-img">
        <img [src]="logoUrl" alt="Apex logo"/>
      </div>
      <span class="align-middle text-right " style="display: inline-block; width: 100%"></span>
    </a>
    <a class="nav-toggle d-none d-lg-none d-xl-block" id="sidebarToggle" href="javascript:;"
      (click)="toggleSidebar()">
      <i #toggleIcon [ngClass]="{
        'ft-toggle-left': config.layout.sidebar.collapsed,
        'ft-toggle-right': !config.layout.sidebar.collapsed
      }" class="toggle-icon"></i>
    </a>
    <a class="nav-close d-block d-lg-block d-xl-none" id="sidebarClose" href="javascript:;" (click)="CloseSidebar()">
      <i class="ft-x"></i>
    </a>
  </div>
</div>
<!-- Sidebar Header Ends -->

<!-- Sidebar Content starts -->
<div class="sidebar-content main-menu-content">
  <div class="nav-container">
    <ul class="navigation" appSidebarDropdown>
      <!-- First level menu -->
      @for (menuItem of menuItems; track menuItem) {
        <li appSidebarlink [parent]="menuItem.title" [path]="menuItem.path | localize" [level]="level + 1" [hasSub]="menuItem.class.includes('has-sub') ? true: false"
            [ngClass]="{'has-sub': menuItem.class.includes('has-sub') ? true: false}"
            [routerLinkActive]="menuItem.submenu.length != 0 ? 'open' : 'active'" [routerLinkActiveOptions]="{exact: false}">
          @if (menuItem.submenu.length > 0 && !menuItem.isExternalLink) {
            <a appSidebarAnchorToggle>
              <i [ngClass]="[menuItem.icon]"></i>
              <span class="menu-title">{{menuItem.title | translate }}</span>
              @if (menuItem.badge && menuItem.badge != '' ) {
                <span [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
              }
            </a>
          }
          @if (menuItem.submenu.length === 0 && !menuItem.isExternalLink) {
            <a appSidebarAnchorToggle [routerLink]=" ('/' + menuItem.path) | localize">
              <i [ngClass]="[menuItem.icon]"></i>
              <span class="menu-title">{{menuItem.title | translate }}</span>
              @if (menuItem.badge && menuItem.badge != '' ) {
                <span [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
              }
            </a>
          }
          @if (menuItem.isExternalLink) {
            <a [routerLink]=" ('/' + menuItem.path) | localize" target="_blank">
              <i [ngClass]="[menuItem.icon]"></i>
              <span class="menu-title">{{menuItem.title | translate }}</span>
              @if (menuItem.badge && menuItem.badge != '' ) {
                <span [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
              }
            </a>
          }
          <!-- Second level menu -->
          @if (menuItem.submenu.length > 0 ) {
            <ul appSidebarDropdown class="menu-content">
              @for (menuSubItem of menuItem.submenu; track menuSubItem) {
                <li appSidebarlink [parent]="menuItem.title" [hasSub]="menuSubItem.class.includes('has-sub') ? true: false"
                    [path]="menuSubItem.path | localize" [level]="level + 2" [ngClass]="{'has-sub': menuSubItem.class.includes('has-sub') ? true: false}"
                    [routerLinkActive]="menuSubItem.submenu.length != 0 ? 'open' : 'active'">
                  @if (menuSubItem.submenu.length > 0 && !menuSubItem.isExternalLink) {
                    <a appSidebarAnchorToggle>
                      <i [ngClass]="[menuSubItem.icon]"></i>
                      <span class="menu-title">{{menuSubItem.title | translate }}</span>
                      @if (menuSubItem.badge && menuSubItem.badge != '' ) {
                        <span [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                      }
                    </a>
                  }
                  @if (menuSubItem.submenu.length === 0 && !menuSubItem.isExternalLink) {
                    <a appSidebarAnchorToggle [routerLink]=" ('/' + menuSubItem.path) | localize">
                      <i [ngClass]="[menuSubItem.icon]"></i>
                      <span class="menu-title">{{menuSubItem.title | translate }}</span>
                      @if (menuSubItem.badge && menuSubItem.badge != '' ) {
                        <span [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                      }
                    </a>
                  }
                  @if (menuSubItem.isExternalLink) {
                    <a [routerLink]=" ('/' + menuSubItem.path) | localize" target="_blank">
                      <i [ngClass]="[menuSubItem.icon]"></i>
                      <span class="menu-title">{{menuSubItem.title | translate }}</span>
                      @if (menuSubItem.badge && menuSubItem.badge != '' ) {
                        <span [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                      }
                    </a>
                  }
                  <!-- Third level menu -->
                  @if (menuSubItem.submenu.length > 0) {
                    <ul appSidebarDropdown class="menu-content">
                      @for (menuSubsubItem of menuSubItem.submenu; track menuSubsubItem) {
                        <li appSidebarlink data-menu="" data-toggle="dropdown"
                            [parent]="menuItem.title" [level]="level + 3" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">
                          @if (!menuSubsubItem.isExternalLink) {
                            <a appSidebarAnchorToggle data-toggle="dropdown" [ngClass]="'dropdown-item d-flex align-items-center'"
                               [routerLink]=" ('/' + menuSubsubItem.path) | localize">
                              <i [ngClass]="[menuSubsubItem.icon]"></i>
                              <span class="">{{menuSubsubItem.title}}</span>
                              @if (menuSubsubItem.badge && menuSubsubItem.badge != '' ) {
                                <span [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                              }
                            </a>
                          } @else {
                            <a data-toggle="dropdown" [ngClass]="'dropdown-item d-flex align-items-center'"
                               [routerLink]=" ('/' + menuSubsubItem.path) | localize" target="_blank">
                              <i [ngClass]="[menuSubsubItem.icon]"></i>
                              <span class="">{{menuSubsubItem.title}}</span>
                              @if (menuSubsubItem.badge && menuSubsubItem.badge != '' ) {
                                <span [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                              }
                            </a>
                          }
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </div>
</div>
<!-- Sidebar Content Ends -->

